import React, { useContext } from 'react';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import CreateDetailsModal from './component/CreateDetailsModal';
import UpdateDetailsModal from './component/UpdateDetailsModal';
import * as actions from '../../../action';

function DetailsOptionsContainer({
  newTaxRevenuesId,
  calculationsId,
  detailsList,
  removeDetails,
  getDetailsList,
}) {
  const setModal = useContext(ModalContext);

  const handleAddDetails = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <CreateDetailsModal
          newTaxRevenuesId={newTaxRevenuesId}
          calculationsId={calculationsId}
        />
      ),
      title: 'Add Details',
      modalSize: 'modal-md',
    });
  };

  const handleUpdateDetails = (detailsId, val) => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateDetailsModal
          newTaxRevenuesId={newTaxRevenuesId}
          calculationsId={calculationsId}
          id={_.get(detailsList, 'id')}
          detailsId={detailsId}
          updateList={val}
        />
      ),
      title: 'Update Details',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveDetails = detailsId => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this details?',
      () => {
        removeDetails(newTaxRevenuesId, calculationsId, detailsId, () => {
          getDetailsList(newTaxRevenuesId, calculationsId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="row mb-1 pb-1">
      <div className="col-12 d-flex justify-content-end">
        <button
          onClick={handleAddDetails}
          type="button"
          className="btn btn-secondary btn-round font-weight-bold px-4 ml-auto"
        >
          Add &nbsp;
          <i className="fas fa-plus" />
        </button>
      </div>
      <div className="col-12">
        <table className="transaction-table table table-bordered table-sm table-striped table-hover mt-3">
          <thead>
            <tr>
              <td className="text-left">Multiplier</td>
              <td className="text-right">Amount</td>
              <td className="text-right">Actions</td>
            </tr>
          </thead>
          <tbody>
            {detailsList && detailsList.length <= 0 ? (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            ) : (
              ''
            )}
            {detailsList &&
              detailsList.map(item => (
                <tr key={item.id} className="top-border">
                  <td className="text-left">
                    {_.get(item, 'attributes.multiplier')}
                  </td>
                  <td className="text-right">
                    {_.get(item, 'attributes.amount_human')}
                  </td>
                  <td className="text-right">
                    <button
                      onClick={handleUpdateDetails(
                        _.get(item, 'id'),
                        _.get(item, 'attributes')
                      )}
                      type="button"
                      className="btn-blank"
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemoveDetails(_.get(item, 'id'))}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

DetailsOptionsContainer.propTypes = {
  newTaxRevenuesId: PropTypes.string.isRequired,
  calculationsId: PropTypes.string.isRequired,
  detailsList: PropTypes.instanceOf(Object).isRequired,
  removeDetails: PropTypes.instanceOf(Function).isRequired,
  getDetailsList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DetailsOptionsContainer);
